import { SimpleSignal } from "./SimpleSignal";

export interface IResizeManagerConfig
{
	delay?: number;
	target?: EventTarget;
	handler?: Function;
	callNow?: boolean;
}

export class ResizeManager
{

	// ===========================================================================================================
	// Static ----------------------------------------------------------------------------------------------------

	public static autoEnable = true;

	public static defaultConfig: IResizeManagerConfig = {
		delay: 100
	};

	private static _singleton:ResizeManager;

	static getInstance(config?:IResizeManagerConfig):ResizeManager
	{
		return ResizeManager._singleton || (ResizeManager._singleton = new ResizeManager(config));
	}


	// ===========================================================================================================
	// constructor -----------------------------------------------------------------------------------------------

	public delay:number;
	public resizeSignal:SimpleSignal;

	private _timeoutId:number = 0;
	private _target:EventTarget;
	private _enabled:boolean = false;

	constructor(config?:IResizeManagerConfig)
	{
		config = config || ResizeManager.defaultConfig;

		this.delay   = config.delay  || ResizeManager.defaultConfig.delay;
		this._target = config.target || window;

		this.resizeSignal = new SimpleSignal();

		if (ResizeManager.autoEnable)
		{
			this.enable();
		}

		if (config.handler)
		{
			var callNow = config.callNow !== undefined ? callNow : true;
			this.add(config.handler, callNow);
		}
	}

	public add(handler:Function, callNow:boolean):void
	{
		this.resizeSignal.add(handler);
		if (callNow)
		{
			handler(this);
		}
	}

	public enable():void
	{
		if (this._enabled)
		{
			return;
		}

		this._target.addEventListener("resize", this.onResize);
		this._enabled = true;
	}

	public disable():void
	{
		if (!this._enabled)
		{
			return;
		}

		this._target.removeEventListener("resize", this.onResize);

		this._enabled = false
	}

	private onResize = (event:Event):void =>
	{
		if (this.delay > 0)
		{
			if (this._timeoutId)
			{
				clearTimeout(this._timeoutId);
			}
			this._timeoutId = window.setTimeout(this.trigger, this.delay);
		}
	};

	public trigger = ():void =>
	{
		this.resizeSignal.dispatch(this);
		this._timeoutId = 0;
	}
}